"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVNET_PYTH_MINT = exports.MAINNET_PYTH_MINT = exports.REALM_ID = exports.STAKING_ADDRESS = exports.GOVERNANCE_ADDRESS = exports.DEVNET_ENDPOINT = exports.MAINNET_ENDPOINT = void 0;
const web3_js_1 = require("@solana/web3.js");
const StakeConnection_1 = require("./StakeConnection");
exports.MAINNET_ENDPOINT = "https://api.mainnet-beta.solana.com";
exports.DEVNET_ENDPOINT = "https://api.devnet.solana.com";
function GOVERNANCE_ADDRESS() {
    return new web3_js_1.PublicKey(StakeConnection_1.wasm.Constants.GOVERNANCE_PROGRAM());
}
exports.GOVERNANCE_ADDRESS = GOVERNANCE_ADDRESS;
exports.STAKING_ADDRESS = new web3_js_1.PublicKey("sta99txADjRfwHQQMNckb8vUN4jcAAhN2HBMTR2Ah6d");
exports.REALM_ID = new web3_js_1.PublicKey("A1f6LNEymJSSJsEVCL1FSgtS1jA9dNTC4ni8SkmbwQjG");
exports.MAINNET_PYTH_MINT = new web3_js_1.PublicKey("3ho8ZM4JVqJzD56FADKdW7NTG5Tv6GiBPFUvyRXMy35Q");
exports.DEVNET_PYTH_MINT = new web3_js_1.PublicKey("7Bd6bEH4wHTMmov8D2WTXgxzLJcxJYczqE5NaDtZdhF6");
